import React from 'react'
// libs
import NProgress from 'nprogress'
import { useRouter } from 'hooks/useRouter'
// components
import { Link as RouterLink } from 'react-router'
// themes
import { EllipsizedText } from 'themes/views/generic'
// hooks
import { useCurrentUser } from 'hooks/index'
// views
import { FixedSidebar, NavigationCell, NavigationWrapper, Paper } from './views'
// types
import { ConfigItem } from 'layouts/types'

interface Props {
  config: ConfigItem[]
}

const NavigationSidebar: React.FC<Props> = ({ config }) => {
  const user = useCurrentUser()
  const router = useRouter()

  const {
    permissionsFromSecurityGroups: { aiViewUsage }
  } = user

  const filteredConfig = config.filter(({ name }) => {
    if (name === 'Power BI') {
      return user.isAdmin
    }

    if (name === 'AI Usage') {
      return aiViewUsage
    }

    return true
  })

  return (
    <FixedSidebar>
      <Paper square elevation={0}>
        <NavigationWrapper>
          {filteredConfig.map(({ getLink, name, icon, path, determineIsActive }) => {
            const isActive = determineIsActive
              ? determineIsActive(router.query.slug?.[0] as string)
              : path.some((p: string) => {
                  // Strip Next.js dynamic segments for matching
                  const basePath = p.split('/[')[0]
                  return router.pathname === basePath || router.pathname.startsWith(basePath + '/')
                })

            return (
              <RouterLink
                key={name}
                to={getLink({ user }) as string}
                onClick={() => NProgress.start()}
                style={{ textDecoration: 'none' }}>
                <NavigationCell $isActive={isActive}>
                  {React.cloneElement(icon, { isActive })}
                  <EllipsizedText>{name}</EllipsizedText>
                </NavigationCell>
              </RouterLink>
            )
          })}
        </NavigationWrapper>
      </Paper>
    </FixedSidebar>
  )
}

export default NavigationSidebar
